<!--
/*******************************************************************************
*@ 컴포넌트명   : TermiAnticiInq.vue
*@ 컴포넌트설명 : 예금해지예상조회
*@ 사용전문     : RBF0406D40 - 예금해지예상조회
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 
********************************************************************************/
-->
<template>
  <div>
    <div class="account-info -type4">
      <div class="tit">{{ acnOtPutNm }}</div>
      <div class="desc">
        <div class="item account">{{ depositTermi.expectation.acno }} - {{ acnOtPutNm }}</div>
      </div>
      <div class="sub">
        <progress-bar :percent="percent">
          <template #term>
            <template v-if="RBF0404B40.acnDtailCd === '4'">{{ /*{1}회차*/ $t("MDEP-02-01-08-16", { 1: $n(RBF0404B40.totalPaymtzNth) }) }}</template>
            <template v-else>{{ /*재예치기간2*/ RBF0404B40.ctrcTrmCnt }}{{ RBF0404B40.ctrcUnitDstcd }}</template>
          </template>
          <template #start>
            {{ /*시작일*/ $t("MDEP-02-01-08-03") }}
            <br />
            {{ $getGlobalDateFmt(RBF0404B40.newYmd) }}
          </template>
          <template #end>
            {{ /*만기일*/ $t("MDEP-02-01-08-04") }}
            <br />
            {{ $getGlobalDateFmt(RBF0404B40.expirYmd) }}
          </template>
          <template #ing>
            {{ days }}
            <br />
            <em>days</em>
          </template>
        </progress-bar>
      </div>
    </div>
    <div class="cont-tit">
      <h6>{{ /*해지예상조회*/ $t("MDEP-02-01-01-10") }}</h6>
    </div>
    <dl class="dlist dlist-item--type4">
      <dt>{{ /*조회일자*/ $t("MDEP-02-01-07-06") }}</dt>
      <dd>{{ $getGlobalDateFmt(depositTermi.expectation.regYmd) }}</dd>
      <dt>{{ /*계좌번호*/ $t("MDEP-02-01-07-07") }}</dt>
      <dd>{{ depositTermi.expectation.acno }}</dd>
      <dt>{{ /*계좌명*/ $t("MDEP-02-01-07-08") }}</dt>
      <dd>{{ acnOtPutNm }}</dd>
      <dt>{{ /*해지일*/ $t("MDEP-02-01-07-09") }}</dt>
      <dd>{{ $getGlobalDateFmt(depositTermi.expectation.termiYmd) }}</dd>
      <dt>{{ /*통화*/ $t("MDEP-02-01-07-10") }}</dt>
      <dd>{{ depositTermi.expectation.cncycd }}</dd>
      <dt>{{ /*원금*/ $t("MDEP-02-01-07-11") }}</dt>
      <dd>
        <span class="bold">{{ $num(depositTermi.expectation.prcpl) }}</span>
      </dd>
      <dt>{{ /*이자*/ $t("MDEP-02-01-07-12") }}</dt>
      <dd>
        <span class="bold">{{ $num(depositTermi.expectation.termiPtimExpirIntPaymtAmt) }}</span>
      </dd>
      <dt>{{ /*징수세금*/ $t("MDEP-02-01-07-13") }}</dt>
      <dd>
        <span class="bold">{{ $num(depositTermi.expectation.termiPtimLevyTaxAmt) }}</span>
      </dd>
      <template v-if="depositTermi.expectation.prviusPaymtYn == 'Y'">
        <dt>{{ /*기지급이자*/ $t("MDEP-02-01-07-18") }}</dt>
        <dd>
          <span class="bold">{{ $num(depositTermi.expectation.prviusPaymtIntAmt) }}</span>
        </dd>
        <dt>{{ /*기징수세액*/ $t("MDEP-02-01-07-19") }}</dt>
        <dd>
          <span class="bold">{{ $num(depositTermi.expectation.prviusLevyTaxAmt) }}</span>
        </dd>
      </template>
      <dt>{{ /*예상 지급 금액*/ $t("MDEP-02-01-07-14") }}</dt>
      <dd>
        <span class="bold">{{ $num(depositTermi.expectation.totalPyaccAmt) }}</span>
      </dd>
    </dl>
    <div class="info info-etc">※ {{ /*금리나 세율 변동 시 실제 지급액이 다를 수 있습니다.*/ $t("MDEP-02-01-07-15") }}</div>
  </div>
</template>
<script>
import { mapFields } from "vuex-map-fields";
import { mapActions } from "vuex";
export default {
  props: {
    acno: {
      type: String,
      required: true,
    },
    cncycd: {
      type: String,
      required: true,
    },
    acnOtPutNm: {
      type: String,
      required: true,
    },
  },
  mounted() {
    this.calcPeriod();
  },
  computed: {
    ...mapFields("deposit/termiUpdat", ["depositTermi", "RBF0404B40"]),
  },
  data() {
    return {
      days: "",
      percent: 0,
      term: "",
    };
  },
  methods: {
    ...mapActions(["ACT_SET_SERVERINFO_ALL", "ACT_GET_SERVERINFO_ALL"]),
    async calcPeriod() {
      const globalToday = await this.ACT_GET_SERVERINFO_ALL().then(data => this.moment(data.sysDateTime, "YYYYMMDD").format("YYYYMMDD"));
      this.days = this.moment(globalToday).diff(this.moment(this.RBF0404B40.newYmd), "days");
      this.$log.info(this.days);
      this.term = this.moment(this.RBF0404B40.expirYmd).diff(this.moment(this.RBF0404B40.newYmd), "days");
      this.$log.info(this.term);
      this.percent = (this.days / this.term) * 100;
      if (this.percent > 100) {
        this.percent = 100;
      }
    },
  },
};
</script>
